export default __webpack_public_path__ + "static/media/06-family.a13b42ef.jpg";